import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';


@Component({
  selector: 'ngx-hacerse-socio',
  templateUrl: './hacerse-socio.component.html',
  styleUrls: ['./hacerse-socio.component.scss'],
  providers: [UtilidadesService,PeticionesHttpBackEndService]
})
export class HacerseSocioComponent implements OnInit {

  Objeto: any;
  DatosProfesionalesForm: FormGroup;
  DatosCobroForm: FormGroup;
  thirdForm: FormGroup;
  Finalizando:any;
  Cargo: string = "";
  EmpresaInstitucion: String = "";
  Especialidad: Array<any> = [];
  Actividad: Array<any> = [];
  FormaPago: Array<any> = [];
  RecibirOfertasEmpleo: Number = 0;
  IncluirDirectorio: Number = 0;
  Finalizado:any;
  EntidadBancaria: String = "";
  IBAN: String = "";

  ListadoActividadesProfesionales: any;
  ListadoEspecialidadesProfesionales: any;
  ListadoFormasPago: any;

  muestraContenidoFinal: Boolean = false;
  finalExito: Boolean = false;

  // TODO Da el error de propiedad indefinida por que se accede al array a traves del id seleccionado y eso no es correcto.
  // Habría que hacer una peticion http para saber el nombre de la forma de pago, actividad, especialidad.
  
  constructor(private fb: FormBuilder, private utilidades: UtilidadesService, private router:Router,public _http: PeticionesHttpBackEndService) { 
    this.ListadoActividadesProfesionales = {Actividades:[]};
    this.ListadoEspecialidadesProfesionales = {Especialidades:[]};
    this.ListadoFormasPago = {FormasPago:[]};
    this.FormaPago.push({Id:0,Nombre:''});
    this.Especialidad.push({Id:0,Nombre:''});
    this.Actividad.push({Id:0,Nombre:''});
  }

  ngOnInit() {

    this._http.getAllReg("v1/EntidadesActividades").subscribe(
      result => {
        this.ListadoActividadesProfesionales = result;
        this.ListadoActividadesProfesionales.Actividades.push({_entidad_actividad_id:0,_nombre:"Seleccione actividad"});
      },
      error => {

      }
    );

    this._http.getAllReg("v1/EntidadesEspecialidades").subscribe(
      result => {
        this.ListadoEspecialidadesProfesionales = result;
        this.ListadoEspecialidadesProfesionales.Especialidades.push({_entidad_especialidad_id:0,_nombre:"Seleccione especialidad"});
      },
      error => {

      }
    );

    this._http.getAllReg("v1/FormasPago").subscribe(
      result => {
        this.ListadoFormasPago = result;
        this.ListadoFormasPago.FormasPago.push({_forma_pago_id:0,_nombre:"Seleccione forma de pago"});
      },
      error => {

      }
    );
    

    this.DatosProfesionalesForm = this.fb.group({
      Cargo: ['', Validators.required],
      EmpresaInstitucion: ['', Validators.required],
      Especialidad: ['', Validators.required],
      Actividad: ['', Validators.required],
    });

    this.DatosCobroForm = this.fb.group({
      FormaPagoId: ['', Validators.required],
      EntidadBancaria: ['', Validators.required],
      IBAN: ['', Validators.required],
    });

   
    
  }


  onThirdSubmit() {
    this.thirdForm.markAsDirty();
  }

  setDatoObjeto(event){
    let elemento = event.target.tagName;
    let tipo = event.target.type;
    if (elemento == "INPUT" && tipo == "text"){
      switch(event.target.name){
        case "Cargo": this.Cargo = event.target.value; break;
        case "EmpresaInstitucion": this.EmpresaInstitucion = event.target.value; break;
        case "Especialidad": this.Especialidad = event.target.value; break;
        case "Actividad": this.Actividad = event.target.value; break;
        case "EntidadBancaria": this.EntidadBancaria = event.target.value; break;
        case "IBAN": this.IBAN = event.target.value; break;
      }
      }
      
      /* if (elemento == "textarea"){
        switch(event.target.name){
          case "_motivo": this.MotivoBaja = event.target.value; break;
        }
      }
      */
  
    if (elemento == "INPUT" && tipo == "checkbox"){
      switch(event.target.name){
        case "RecibirOfertasEmpleo": 
        if (event.target.checked == true){
          this.RecibirOfertasEmpleo = 1;
        }else{
          this.RecibirOfertasEmpleo = 0;
        }
        break;
        case "IncluirDirectorio": 
        if (event.target.checked == true){
          this.IncluirDirectorio = 1;
        }else{
          this.IncluirDirectorio = 0;
        }
        break;
      }
    }

    if (elemento == "SELECT" && tipo == "select-one"){
      switch(event.target.name){
        case "Especialidad": this.Especialidad = []; this.Especialidad.push({Id:event.target.value,Nombre:event.target.selectedOptions[0].text});break;
        case "Actividad": this.Actividad = []; this.Actividad.push({Id:event.target.value,Nombre:event.target.selectedOptions[0].text});break;
        case "FormaPagoId": this.FormaPago = []; this.FormaPago.push({Id:event.target.value,Nombre:event.target.selectedOptions[0].text}); break;
      }
    }

  }

  onDatosProfesionalesSubmit(){
    this.DatosProfesionalesForm.markAsDirty();
    if (this.DatosProfesionalesForm.status == "INVALID" || this.Especialidad[0].Id == 0 || this.Actividad[0].Id == 0){
      this.utilidades.notificationWarning("Aviso","Tienes que rellenar todos los campos","top-left");
      return false;
    }else{
      return true;
    }
  }

  onDatosCobroSubmit(){
    this.DatosCobroForm.markAsDirty();
    if (this.DatosProfesionalesForm.status == "INVALID" || this.FormaPago[0].Id == 0){
      this.utilidades.notificationWarning("Aviso","Tienes que rellenar todos los campos","top-left");
      return false;
    }else{
      return true;
    }
  }

  onConfirmaDatos(){
    let Resultado;
    this.Objeto = {Cargo:this.Cargo, EmpresaInstitucion:this.EmpresaInstitucion, Especialidad:this.Especialidad[0].Id, Actividad:this.Actividad[0].Id, RecibirOfertasEmpleo: this.RecibirOfertasEmpleo, IncluirDirectorio: this.IncluirDirectorio, EntidadBancaria: this.EntidadBancaria, IBAN: this.IBAN, FormaPago: this.FormaPago[0].Id};
    this._http.postRequest("v1/solicitudAltaSocio",{Data:this.Objeto}).subscribe(
      result => {
        Resultado = result;
          if (Resultado.Code == 200){
            this.utilidades.notificationSuccess("Aviso","Solicitud de alta realizada con éxito","top-left");   
            this.muestraContenidoFinal = true;
            this.finalExito = true;
          }else if(Resultado.Code == 1000){
            this.utilidades.notificationWarning("Error "+Resultado.Code+"",""+Resultado.Mensaje+"","top-left");
            this.muestraContenidoFinal = true;
            return false;
          }
      }
    );    
    return true;
  }

  FinalizaRegistro(){
    this.router.navigate(['private/perfil-usuario']);
    return true;
  }


}
